import { createFileRoute } from '@tanstack/react-router';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { buscaDaEquipe } from '@/features/usuarios/busca';
import { ListaDeMembros } from '@/features/usuarios/componentes/ListaDeMembros';

export const Route = createFileRoute('/_autenticado/equipe/')({
  ...rotaDeTela('equipe.lista'),
  validateSearch: buscaDaEquipe,
  component: Pagina,
});

function Pagina() {
  const filtros = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ListaDeMembros
      grupo="equipe"
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
